// WHERE A FAIR PRICE CAME FROM, in the punter's own words.
//
// A leaf with no imports, because two screens say this and they must say it
// identically: the ticket, under a single's Fair line, and the Match page,
// under the price table. The arithmetic behind it is `consensus`'s `mode`
// (src/lib/engine/universe.js): where a sharp reference prices the side — the
// exchange with money behind it, or Pinnacle — the fair price is that price
// alone, net of commission, and the local board is not averaged into it.
//
// The reason it is worth a line at all is the reviewer's, and it is about this
// market rather than about arithmetic: five Australian books are one opinion in
// five coats. Most of them buy the same feed, so a consensus over all of them
// is one opinion wearing a tight error bar. A punter reading "fair" is owed the
// difference between a price money moved and a price five shops copied.

/** `consensus` mode → the phrase the screens print. */
export const FAIR_FROM = Object.freeze({
  sharp: 'fair from the exchange',
  local: 'fair from local books only',
});

/**
 * WHAT A LINE OF FIGURES HAS ROOM FOR. The same fact in two or three words,
 * for a ticket's Fair line, which is a row of numbers on a 320px phone and
 * cannot carry a sentence: "Fair 3.06 · +4.6% · local books".
 *
 * The full phrase is what a screen reader hears and what the Match page prints,
 * so nothing is lost — it is said where there is room to say it.
 */
export const FAIR_FROM_SHORT = Object.freeze({
  sharp: 'exchange',
  local: 'local books',
});

/**
 * The phrase for a mode, or '' for a reading that predates the question.
 *
 * `source` is the book the sharp price was actually read off. It is the
 * exchange on every Australian board there has ever been, and Pinnacle only on
 * imported football history — which is named rather than called an exchange,
 * because it is not one.
 */
export function fairFrom(mode, source = null) {
  if (mode === 'sharp' && isPinnacle(source)) return 'fair from Pinnacle';
  return FAIR_FROM[mode] ?? '';
}

/** The same, in two or three words. '' for a reading that predates the question. */
export function fairFromShort(mode, source = null) {
  if (mode === 'sharp' && isPinnacle(source)) return 'Pinnacle';
  return FAIR_FROM_SHORT[mode] ?? '';
}

const isPinnacle = (source) => !!source && source !== 'betfair_ex_au';
